import React from 'react';
import { Card, Alert, Button } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';

/**
 * AlertPanel - Panel de alertas y acciones recomendadas
 * @param {Array} alerts - Array de alertas con prioridad (urgent, warning, info)
 */
const AlertPanel = ({ alerts = [] }) => {
    const { t } = useTranslation();

    if (alerts.length === 0) {
        return (
            <Card>
                <Card.Body>
                    <Card.Title>{t('dashboard.alerts')}</Card.Title>
                    <p className="text-muted text-center py-3">
                        {t('dashboard.noAlerts')}
                    </p>
                </Card.Body>
            </Card>
        );
    }

    const getAlertVariant = (priority) => {
        switch (priority) {
            case 'urgent':
                return 'danger';
            case 'warning':
                return 'warning';
            case 'info':
            default:
                return 'info';
        }
    };

    const getAlertIcon = (priority) => {
        switch (priority) {
            case 'urgent':
                return '🔴';
            case 'warning':
                return '🟡';
            case 'info':
            default:
                return '🟢';
        }
    };

    return (
        <Card>
            <Card.Body>
                <Card.Title className="mb-3">{t('dashboard.alerts')}</Card.Title>
                {alerts.map((alert, index) => (
                    <Alert
                        key={index}
                        variant={getAlertVariant(alert.priority)}
                        className="d-flex justify-content-between align-items-center"
                    >
                        <div>
                            <span className="me-2">{getAlertIcon(alert.priority)}</span>
                            <strong>{alert.title}</strong>
                            {alert.description && (
                                <div className="ms-4 mt-1 small">
                                    {alert.description}
                                </div>
                            )}
                        </div>
                        {alert.action && (
                            <Button
                                size="sm"
                                variant={`outline-${getAlertVariant(alert.priority)}`}
                                onClick={alert.action.onClick}
                            >
                                {alert.action.label}
                            </Button>
                        )}
                    </Alert>
                ))}
            </Card.Body>
        </Card>
    );
};

export default AlertPanel;
